<template>
  <div class="my-1 mx-2 d-flex">
    <div class="text-xs-left">
      <slot name="left" />
    </div>
    <div class="text-xs-right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimulationFooterLayout',
}
</script>

<style scoped></style>
